module.exports = __webpack_public_path__ + "fonts/sourcesansprosemibolditalic.1b491708.woff2";